/**
 * Post-Meeting Analytics Types
 *
 * Types for post-meeting analysis, suggestion storage, and emotion timelines.
 * Used by backend services and Meeting Detail Page UI.
 */
// =====================================================
// Repository Types for Action Items (Story 3.6)
// =====================================================
/**
 * Priority levels for action items
 */
export const ActionItemPriority = {
    HIGH: 'high',
    MEDIUM: 'medium',
    LOW: 'low',
};
/**
 * Category types for action items
 */
export const ActionItemCategory = {
    FOLLOW_UP: 'follow-up',
    INTERNAL: 'internal',
    CLIENT_REQUEST: 'client-request',
    OBJECTION_RESPONSE: 'objection-response',
};
/**
 * Source of action item creation
 */
export const ActionItemSource = {
    AI: 'ai',
    MANUAL: 'manual',
    AI_GATE: 'ai_gate',
};
// Display metadata for UI. Record<..., ...> so a new value is a compile error
// until it gets a label here.
export const ActionItemPriorityMetadata = {
    high: { label: 'High' },
    medium: { label: 'Medium' },
    low: { label: 'Low' },
};
export const ActionItemCategoryMetadata = {
    'follow-up': { label: 'Follow-up' },
    internal: { label: 'Internal' },
    'client-request': { label: 'Client Request' },
    'objection-response': { label: 'Objection Response' },
};
export const ActionItemSourceMetadata = {
    ai: { label: 'AI' },
    manual: { label: 'Manual' },
    ai_gate: { label: 'AI Gate' },
};
/**
 * Scope of an action item (personal vs team-wide)
 */
export const ActionItemScope = {
    PERSONAL: 'personal',
    TEAM: 'team',
};
/**
 * Action item stored in database
 */
/**
 * Action type for items that trigger specific workflows
 */
export const ActionItemActionType = {
    WRITE_EMAIL: 'write_email',
    SCHEDULE_MEETING: 'schedule_meeting',
};
/**
 * Visibility scope for the dedicated /action-items page.
 *
 * - `just-me`: items created by or assigned to the requesting user.
 * - `my-team`: all items belonging to a deal the requesting user owns or
 *   collaborates on, including items created by or assigned to them.
 * - `everyone`: full org visibility (read-only). Gated by `org-wide-browse:access`
 *   permission at the route layer; non-admin uses are recorded in the activity
 *   audit log. Per-row `readOnly` is set to `true` for items the requester is
 *   not the creator of, not an assignee on, and not a collaborator on the
 *   parent deal.
 *
 * Default (omitted) means org-wide visibility, subject to other RBAC.
 */
export const ActionItemScopeFilter = {
    JUST_ME: 'just-me',
    MY_TEAM: 'my-team',
    EVERYONE: 'everyone',
};
